import { render, staticRenderFns } from "./postView.vue?vue&type=template&id=72c86492"
import script from "./postView.vue?vue&type=script&lang=js"
export * from "./postView.vue?vue&type=script&lang=js"
import style0 from "./postView.vue?vue&type=style&index=0&id=72c86492&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports